import script from "./ListEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ListEditor.vue?vue&type=style&index=0&id=05f09fc2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f09fc2"]])

export default __exports__